import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import { SectionContext } from '../../../../../../Types';
import { ExperienceResource, ExperiencesResource } from '../../../Types';
import BulkAdder from './BulkAdder';

interface Props {
  filteredExperiences: ExperienceResource[];
  learningCollectionStore: LearningCollectionEditStore;
  experiences: ExperiencesResource;
  context: SectionContext;
}

const SubHeader: React.FC<Props> = ({
  filteredExperiences,
  learningCollectionStore,
  experiences,
  context,
}) => {
  const totalUnfilteredCount = experiences.metadata.resultsCount;
  return (
    <div className="flex">
      <div className="mb-5 mt-5 text-sm text-gray-500">
        <T
          kind="Viewing {{resultsCount}} of {{totalUnfilteredCount}} programs"
          totalUnfilteredCount={totalUnfilteredCount}
          resultsCount={filteredExperiences.length}
        />
      </div>
      <BulkAdder
        filteredExperiences={filteredExperiences}
        learningCollectionStore={learningCollectionStore}
        totalUnfilteredCount={totalUnfilteredCount}
        context={context}
      />
    </div>
  );
};

export default observer(SubHeader);
